


export const PwaHelper = (() => {
	var obj = {};
	obj.SHOULD_SHOW_KEY = 'should_show_pwa';

	obj.shouldShow = () => {
		let shouldShow = localStorage.getItem(obj.SHOULD_SHOW_KEY);
		if (shouldShow === null) {
			return true;
		}
		return false;
	};

	obj.onShowPwaInstallMessage = () => {
		localStorage.setItem(obj.SHOULD_SHOW_KEY, false);
	};

	return obj;
})();
